import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const fetchAppointments = (filter) => {
  const {
    page,
    per_page,
    status,
    appointment_type,
    search_term,
    start_date,
    end_date,
    account_id,
    location_id,
    order_by,
  } = filter;

  if (account_id === 0) {
     return false;
  }

  let statusParam = status ? `&status=${status}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let startDateParam = start_date ? `&start_date=${start_date}` : "";
  let endDateParam = end_date ? `&end_date=${end_date}` : "";
  let appointmentParam = appointment_type
    ? `&appointment_type=${appointment_type}`
    : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return axios.get(
    `${apiServicesUrl}/book-appointment/get-appointments?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${statusParam}${appointmentParam}${searchParam}${startDateParam}${endDateParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const deleteAppointment = (id, account_id, practice_id) => {
  try {
    const response = axios.delete(`${apiServicesUrl}/book-appointment/delete-appointment/${id}?location_id=${practice_id}&account_id=${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {}
};

export const getLocation = (accountId) => {
  if (accountId === 0) {
    return false;
  }
  return axios.get(
    `${apiServicesUrl}/locations/${accountId}?account_id=${accountId}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getAppointmentSlot = (param) => {
  const { locationId, selectedDate, past_date } = param;
  return axios.get(
    `${apiServicesUrl}/appointment-slots?location_id=${locationId}&selected_date=${selectedDate}&past_date=${past_date}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const updateAppointment = (data) => {
  try {
    const response = axios.put(`${apiServicesUrl}/book-appointment/update-appointment`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {}
};

export const getAppointmentSlotData = async (props) => {
  const { location_id, account_id } = props;
  try {
    const response = axios.get(`${apiServicesUrl}/get-appointment-slots?account_id=${account_id}&location_id=${location_id}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateAppointmentTimeSlot = (props) => {
  const { account_id, location_id, updatedValues } = props;
  try {
    const response = axios.put(`${apiServicesUrl}/update-appointment-slots?account_id=${account_id}&location_id=${location_id}`, updatedValues,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const loadAppointmentLink = (accountId) => {
  try {
    const response = axios.get(`${apiServicesUrl}/book-appointment/get-slug?account_id=${accountId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {}
};
